import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { clientMutation } from '../../../../../../../core/data/GraphQLApi';
import { endpoints } from '../../../../../../../core/defaultValues';

export const updateEscalationConfig = createAsyncThunk(
    'escalation/updateConfig',
    async (configData, { rejectWithValue }) => {
        try {
            const response = await clientMutation(
                `
                mutation updateDriverCaseAccountConfig($config: AWSJSON!, $configType: String!) {
                    updateDriverCaseAccountConfig(config: $config, configType: $configType)
                }`,
                {
                    config: JSON.stringify({
                        isEnabled: configData.config.isEnabled,
                        escalationSteps: configData.config.escalationSteps
                    }),
                    configType: "functions_escalation"
                },
                endpoints.GRAPHQL_GENERAL_V2
            );
            
            // Check for GraphQL errors in response
            if (response.errors && response.errors.length > 0) {
                return rejectWithValue(response.errors[0].message);
            }
            
            return { success: response.updateDriverCaseAccountConfig };
        } catch (error) {
            // Handle network or other errors
            const errorMessage = error.errors?.[0]?.message || error.message || 'Unknown error';
            return rejectWithValue(errorMessage);
        }
    }
);

const escalationSlice = createSlice({
    name: 'escalation',
    initialState: {
        config: null,
        loading: false,
        update: null,
        error: null
    },
    reducers: {
        resetEscalation: (state, action) => {
            if (action.payload) {
                Object.keys(action.payload).forEach(key => {
                    state[key] = action.payload[key];
                });
            }
        },
        clearError: (state) => {
            state.error = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(updateEscalationConfig.pending, (state) => {
                state.update = null;
                state.error = null;
            })
            .addCase(updateEscalationConfig.fulfilled, (state, action) => {
                state.update = action.payload;
            })
            .addCase(updateEscalationConfig.rejected, (state, action) => {
                state.update = { success: false, error: action.payload };
                state.error = action.payload;
            });
    }
});

export const { resetEscalation, clearError } = escalationSlice.actions;
export default escalationSlice.reducer;